import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { useFetch } from 'common.ui';
import Page from 'components/page/Page';
import SecurityGroupMappingForm from 'components/entra/SecurityGroupMappingForm';
import { entraClient, rolesClient } from 'api/AdgangClients';
import RoutePaths from 'RoutePaths';

interface IParams {
  id: string;
}

function RoleSecurityGroup() {
  const { id } = useParams<IParams>();
  const history = useHistory();
  const roleId = +id;

  const [role] = useFetch(async () => rolesClient.getRolebyId({ id: roleId }), undefined, false, [id]);

  return (
    <Page header='Entra-sikkerhetsgruppe' title={['Rolle', role?.name || '']}>
      <SecurityGroupMappingForm
        key={id}
        entityId={id}
        entityLabel='rollen'
        holdersText='har rollen'
        entityName={role?.name}
        fetchMapping={() => entraClient.apiEntraRolesRoleIdSecurityGroupGet({ roleId })}
        saveMapping={(securityGroupId) =>
          entraClient.apiEntraRolesRoleIdSecurityGroupPut({
            roleId,
            setRoleSecurityGroupRequest: { securityGroupId }
          })
        }
        syncMembers={() => entraClient.apiEntraRolesRoleIdSyncPost({ roleId })}
        onBack={() => history.push(RoutePaths.rolesDetail.replace(':id', id))}
      />
    </Page>
  );
}

export default RoleSecurityGroup;
